<div style="min-width:300px;">
  <span> <button class="btn btn border" (click)="saveCountry()">Spara</button> <button class="btn btn border"
      style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br>
  <hr /><br>
  <form [formGroup]="form">

    <div class="row">
      <div class="col-md-6">
        <label>
          Iso Code
        </label>
        <input id="isoCode" type="text" class="form-control form-control-sm" formControlName="isoCode">
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label>
          Namn
        </label>
        <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label>
          Sorteringsordning
        </label>
        <input id="order" type="text" class="form-control form-control-sm" formControlName="order">
      </div>
    </div>

  </form>

</div>

